import React, { useContext, useEffect, useState } from 'react'
import validator from 'validator'
import getBackgroundImage from '../../../helpers/images/getBackgroundImage'
import API from '../../../services/API'
import AmbuNetLogo from '../../../assets/images/ambunetLogo.png'

//@MUI
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useNavigate } from 'react-router-dom'
import { Alert, AppBar } from '@mui/material'
import { TenantSettingsContext } from '../../../App'

const CustomField = ({
  label,
  value,
  onChange,
  fullWidth,
  name,
  autoComplete,
  type,
  error,
  helperText,
}) => (
  <Grid item xs={12} lg={fullWidth ? 12 : 6}>
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      fullWidth
      autoComplete={autoComplete}
      name={name}
      id={name}
      type={type}
      required={true}
      error={error}
      helperText={helperText}
      InputProps={{ style: { backgroundColor: 'white', opacity: 1 } }}
      inputProps={{
        autoComplete: autoComplete,
        form: {
          autoComplete: autoComplete,
        },
      }}
    />
  </Grid>
)

const EventOrgSignUp = () => {
  const [bgImage, setBgImage] = useState()
  useEffect(() => {
    setBgImage(getBackgroundImage())
  }, [])
  const navigate = useNavigate()
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [confirmEmail, setConfirmEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [companyRole, setCompanyRole] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [organisationName, setOrganisationName] = useState('')
  const [emailError, setEmailError] = useState(null)
  const [passwordError, setPasswordError] = useState(null)
  const [submissionAttempt, setSubissionAttempt] = useState(false)
  const [error, setError] = useState(null)
  const [submitSuccess, setSubmitSuccess] = useState(false)

  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const handleSubmit = (e) => {
    e.preventDefault()
    setSubissionAttempt(true)
    setEmailError(null)
    setPasswordError(null)
    setError(null)
    const check = (callback) => {
      let errors = false
      if (email !== confirmEmail) {
        setEmailError('Email Addresses do not match')
        errors = true
      } else if (!validator.isEmail(email)) {
        setEmailError('Not a valid Email')
        errors = true
      }
      if (password !== confirmPassword) {
        setPasswordError('Passwords do not match')
        errors = true
      } else if (
        !validator.isStrongPassword(password, {
          minLength: 8,
          minUppercase: 1,
          minLowercase: 1,
          minNumbers: 1,
          minSymbols: 1,
        })
      ) {
        errors = true
        setPasswordError(
          'Passwords must contain at least: 8 Characters, 1 Number, 1 Uppercase, and 1 Symbol.'
        )
      }
      return callback(errors)
    }

    check((errors) => {
      if (errors) {
        return
      } else {
        API.post('/contact-registration', {
          firstName,
          lastName,
          email,
          password,
          orgNameOnApplication: organisationName,
          phone: phoneNumber,
          companyRole
        }).then((res) => {
          if (res.status === 400) {
            res.data.errorCode === 'emailAlreadyExists' &&
              setError(res.data.error)
          } else if (res.status === 200) setSubmitSuccess(true)
        })
      }
    })
  }
  return (
    <Box
      //   display="flex"
      flexDirection="column"
      gap={4}
      width="100%"
      height="100vh"
      overflow="auto"
      alignItems={{ lg: 'center' }}
      justifyContent="center"
    >
      <Box
        justifyContent="center"
        sx={{
          backgroundImage: `url(${AmbuNetLogo})`,
          backgroundRepeat: 'repeat',
          backgroundSize: '100px',
          minHeight: '100vh',
          minWidth: '100%',
          position: 'absolute',
          top: 0,
          zIndex: -1,
          opacity: 0.5,
        }}
      />
      <Box
        bgcolor="rgba(255, 255, 255, 0.9)"
        // component={Paper}
        padding={1}
        // minHeight="50%"
        // height="100%"
        paddingX={{ xs: 0, lg: 5 }}
        display="flex"
        flexDirection="column"
        flexGrow={1}
        gap={2}
        alignItems="center"
      >
        <Stack textAlign="center" height="100%">
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              lg={6}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Stack>
                <Typography color="#135275" variant="title2">
                  {orgSettings?.orgName}
                </Typography>
                <Typography color="#135275" variant="title3">
                  Event Organiser Portal
                </Typography>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              lg={6}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              <Box
                display="flex"
                width="100%"
                justifyContent="center"
                maxHeight="4rem"
                component={Paper}
              >
                <Box
                  component="img"
                  src={orgSettings?.logo}
                  maxHeight="4rem"
                  sx={{ objectFit: 'contain' }}
                  bgcolor={orgSettings?.logobackgroundColor}
                  padding={1}
                  width="100%"
                />
              </Box>
            </Grid>
            <Grid item xs={12} display="flex" flexDirection="column" gap={1}>
              <Typography variant="subtitle2">
                Create an Account to access your Event Information
              </Typography>
            </Grid>
          </Grid>
        </Stack>
        <Grid container spacing={1} component="form" onSubmit={handleSubmit}>
          <CustomField
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            label="First Name"
            autoComplete="given-name"
            name="first-name"
            error={submissionAttempt && !firstName}
          />
          <CustomField
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            label="Last Name"
            autoComplete="family-name"
            name="last-name"
            error={submissionAttempt && !lastName}
          />
          <CustomField
            fullWidth
            value={email}
            onChange={(e) => {
              setEmailError(false)
              setEmail(e.target.value)
            }}
            label="Email"
            autoComplete="email"
            name="email"
            error={(submissionAttempt && !email) || !!emailError}
            helperText={emailError}
          />
          <CustomField
            fullWidth
            value={confirmEmail}
            onChange={(e) => {
              setEmailError(false)
              setConfirmEmail(e.target.value)
            }}
            label="Confirm Email"
            autoComplete="email"
            name="confirm-email"
            error={(submissionAttempt && !confirmEmail) || !!emailError}
            helperText={emailError}
          />
          <CustomField
            value={password}
            onChange={(e) => {
              setPasswordError(false)
              setPassword(e.target.value)
            }}
            label="Password"
            autoComplete="new-password"
            type="password"
            name="new-password"
            error={(submissionAttempt && !password) || !!passwordError}
            helperText={passwordError}
          />
          <CustomField
            value={confirmPassword}
            onChange={(e) => {
              setPasswordError(false)
              setConfirmPassword(e.target.value)
            }}
            label="Confirm Password"
            autoComplete="new-password"
            type="password"
            name="confirm-new-password"
            error={(submissionAttempt && !confirmPassword) || !!passwordError}
            helperText={passwordError}
          />
          <CustomField
            fullWidth
            value={organisationName}
            onChange={(e) => setOrganisationName(e.target.value)}
            label="Organisation Name"
            error={submissionAttempt && !organisationName}
            helperText="The Event Organiser / Customer you are registering on behalf of."
          />
          <CustomField
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            label="Phone Number"
            autoComplete="tel-national"
            error={submissionAttempt && !phoneNumber}
          />
          <CustomField
            value={companyRole}
            onChange={(e) => setCompanyRole(e.target.value)}
            label="Role/Position"
            autoComplete="organization-title"
            error={submissionAttempt && !companyRole}
          />
          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              color="success"
              variant="contained"
              type="submit"
              fullWidth
              endIcon={<ChevronRightIcon />}
              disabled={submitSuccess}
            >
              Continue
            </Button>
          </Grid>
          <Grid item xs={12}>
            {error && <Alert severity="error">{error}</Alert>}
            {submitSuccess && (
              <Alert severity="success" variant="filled">
                Account successfully created. You now need to verify your email
                address by clicking the link on the email sent to you.{' '}
              </Alert>
            )}
          </Grid>
        </Grid>
      </Box>
      <AppBar position="relative" sx={{ backgroundColor: '#3d5c6b' }}>
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          gap={2}
          padding={2}
          alignItems="center"
        >
          <Box component="img" width={70} height={70} src={AmbuNetLogo} />
          <Stack>
            <Typography variant="caption" color="whitesmoke">
              This system is powered by AmbuNet&#174;. While AmbuNet&#174;
              provides the technical platform for accessing these records, it is
              not liable for the accuracy of the information or any decisions
              made based on the data provided. The responsibility for proper and
              authorised use of this system lies with the user and the
              organisation issuing the access. For technical assistance with
              this platform, you may contact AmbuNet support at
              support@ambunet.co.uk. Please note that AmbuNet support cannot
              assist with medical queries or the content of the records.
            </Typography>
          </Stack>
          <Box width={100} height={{ xs: 100, lg: 0 }} />
        </Stack>
      </AppBar>
    </Box>
  )
}

export default EventOrgSignUp
